import React, { useState, useCallback, useRef, type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import EditorPanelIcon from '@atlaskit/icon/core/migration/information--editor-panel';
import EnterEscapeHandler from '@atlassian/jira-common-components-enter-escape-handler/src/index.tsx';
import { JiraInlineDialog as InlineDialog } from '@atlassian/jira-inline-dialog/src/ui/jira-inline-dialog.tsx';

export type Props = {
	buttonText: string;
	content: ReactNode;
};

export const WhatIsThis = (props: Props) => {
	const [isOpen, setIsOpen] = useState(false);

	const onClose = useCallback(() => setIsOpen(false), [setIsOpen]);

	const buttonRef = useRef<unknown>(null);

	const onToggle: () => void = useCallback(() => {
		// we need to focus the button so that pressing ESC will close the popup
		if (buttonRef.current !== undefined && buttonRef.current !== null) {
			// @ts-expect-error - TS2571 - Object is of type 'unknown'.
			buttonRef.current.focus();
		}

		setIsOpen(!isOpen);
	}, [buttonRef, setIsOpen, isOpen]);

	return (
		<Container>
			<InlineDialog
				onClose={onClose}
				content={props.content}
				isOpen={isOpen}
				placement="right"
				onContentBlur={onClose}
				messageId="project-settings-apps-issue-type-page-product-features.common.ui.field-category.what-is-this.inline-dialog"
				messageType="transactional"
			>
				<EnterEscapeHandler onEscape={onClose}>
					<Button
						appearance="subtle"
						isSelected={isOpen}
						onClick={onToggle}
						// @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'Ref<HTMLElement> | undefined'.
						ref={buttonRef}
						iconBefore={<EditorPanelIcon LEGACY_size="medium" spacing="spacious" label="" />}
						aria-label={props.buttonText}
					/>
				</EnterEscapeHandler>
			</InlineDialog>
		</Container>
	);
};

// We want to allow translated messages to be broken up across multiple lines

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div<{
	children?: ReactNode;
}>({
	whiteSpace: 'pre-line',
});
